import { render, staticRenderFns } from "./editShopComponent.vue?vue&type=template&id=8b85faf8&"
import script from "./editShopComponent.vue?vue&type=script&lang=js&"
export * from "./editShopComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports